/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/extensions,
  import/no-extraneous-dependencies,
  import/no-named-as-default,
  no-undef,
  react/no-find-dom-node
*/
import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import createReactClass from 'create-react-class';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Button from 'common/components/button';
import logger from 'common/logger';
import HfReactHelper from 'common/utils/hf-react-helper';
import SubHeaderDelegate from 'signer/components/common/sub-header-delegate';
import DisclosureModal from 'ui/disclosure-modal';
import SigDoc from 'hellospa/components/signer-signature-document';
import Header from './header.jsx';

/**
 */

const messages = defineMessages({
  ok: {
    id: '',
    defaultMessage: 'OK',
    description: 'button text in modal in signature request preview page, understood, closes the modal when clicked',
  },
  buttonText: {
    id: 'signer.preview.esignDisclosure.buttonText',
    defaultMessage: 'Got it',
    description: 'button text in disclosure modal when clicked submits the acceptance of disclosure',
  },
});

const SignatureRequestPreview = createReactClass({

  //  ----  LIFECYCLE  ----------------------------------

  /**
    */

  componentDidMount() {
    logger.track('SignatureRequestPreview.componentDidMount');
    this._trackDataFields();
    // For some reason we need to attach this manually.
    ReactDOM.findDOMNode(this).addEventListener('click', this.onDocumentClick);

    if (this.props.app.showDelegateOnLoad === true) {
      this.props.app.router.displayFullScreenModal('confirmDelegate');
      this.props.app.showDelegateOnLoad = false;
      logger.track('Reassign.Modal.onOpenFromEmail');
    }
  },

  componentWillUnmount() {
    // For some reason we need to attach this manually.
    ReactDOM.findDOMNode(this).removeEventListener('click', this.onDocumentClick);
  },

  /**
     */
  onDocumentClick(evt) {
    let node = evt.target;
    const fieldClass = 'm-signature-document-field';

    // Figure out if parent node is a signature field
    while (HfReactHelper.inArray(fieldClass, node.classList) < 0) {
      node = node.parentNode;
      if (!node || !node.classList) {
        node = null;
        break;
      }
    }

    if (node) {

      // The user has clicked on a component.
      // Prevent the event from bubbling up to avoid things from happening right
      // before we redirect to the next view.
      evt.preventDefault();
      evt.stopPropagation();
    }
  },

  getInitialState() {
    const esignDisclosure = this.props.app.esignDisclosure || {};

    return {
      showWarningModal: this.props.signatureRequest.isTest,
      showDisclosureModal: false,
      startEnabled: !esignDisclosure.enabled || esignDisclosure.userOptIn,
      esignDisclosure,
    };
  },

  /**
     */

  _trackDataFields() {

    const numFieldsWithDataValidation = this.props.signatureRequest.fields.filter((field) => {
      return field.hasDataValidation();
    }).length;

    if (numFieldsWithDataValidation > 0) {
      logger.track('SignatureRequestPreview._hasDataValidation', {
        value: numFieldsWithDataValidation,
      });
    }
  },


  //  ----  BEHAVIOR  -----------------------------------

  /**
     * Show the warning modal
     */
  showWarningModal() {
    this.setState({
      showWarningModal: true,
    });
  },

  /**
     * Close the warning modal
     */
  closeWarningModal(evt) {
    evt.preventDefault();
    this.setState({
      showWarningModal: false,
    });
  },

  /**
     * Show the disclosure modal
     */
  showDisclosureModal() {
    this.setState({
      showDisclosureModal: true,
    });
  },

  /**
     * Close the disclosure modal
     */
  closeDisclosureModal(evt) {
    evt.preventDefault();
    this.setState({
      showDisclosureModal: false,
    });
  },

  /**
     * Download disclosure text
     */
  downloadDisclosureText() {
    window.location = `/home/getDisclosure?tsm_guid=${this.props.app.signatureRequest.transmissionGuid
    }&esign_disclosure_id=${this.state.esignDisclosure.id
    }&user_culture=${this.props.locales[0].replace('-', '_')}`;
  },

  optIn() {
    // send optin request
    const signatureRequest = this.props.app.signatureRequest;
    const self = this;

    signatureRequest.optIn(this.state.esignDisclosure.id).then(() => {
      self.setState({ startEnabled: true });
    });
  },

  //  ----  RENDERING  ----------------------------------

  /**
    */

  render() {
    // Test warning modal
    let warningModal;
    if (this.state.showWarningModal) {
      warningModal = this.renderWarningModal();
    }

    let disclosureModal;
    if (this.state.showDisclosureModal) {
      disclosureModal = this.renderDisclosureModal();
    }

    return <div className='m-signature-request-preview'>
      <Header
        {...this.props}
        startEnabled={this.state.startEnabled}
        optIn={this.optIn}
        showEsignDisclosureModal={this.showDisclosureModal}
        esignDisclosure={this.state.esignDisclosure} />
      <SubHeaderDelegate {...this.props} />
      <SigDoc
        isPreview={true}
        startEnabled={this.state.startEnabled}
        dateFormat={this.props.signatureRequest.settings.dateFormat}
        legacyApp={this.props.app} />
      { warningModal }
      { disclosureModal }
    </div>;
  },

  renderWarningModal() {

    // TODO - needs to be internationalized (CC)
    return <div className='m-signature-request-preview--test-warning'>
      <div className='m-signature-request-preview--test-warning--overlay'></div>
      <div className='m-signature-request-preview--test-warning--content'>
        <FormattedMessage
          id=''
          defaultMessage='<h3>This is not legally binding</h3>
          <p>This is a mock signature request and has no legal value.</p>'
          description='pop up message in when accessing preview of signature request, stating that this is not legal binding'
          values={{
            h3: (msg) => <h3>{msg}</h3>,
            p: (msg) => <p>{msg}</p>,
          }} />
        <Button
          buttonText={this.props.intl.formatMessage(messages.ok)}
          buttonColor='cerulean'
          buttonHoverColor='cerulean'
          buttonTextColor='white'
          buttonTextUppercase={true}
          buttonHoverTextColor='white'
          buttonHoverBorderColor='cerulean'
          buttonBorderColor='cerulean'
          onClick={this.closeWarningModal} />
      </div>
    </div>;
  },

  renderDisclosureModal() {
    const placeholder = /\$BUSINESS_NAME\$/g;
    const { intl } = this.props;
    const businessName = this.state.esignDisclosure.businessName || '';
    const header = 'Agreement to do business electronically with $BUSINESS_NAME$'.replace(placeholder, businessName);
    let text = '<p>Described below are the terms and conditions for providing to you documents and disclosures electronically through the HelloSign electronic signing system. If you consent to receiving notices and disclosures in electronic format based on the terms and conditions described below, please let us know by clicking the &lsquo;I agree&rsquo; button.</p><p>By checking the &lsquo;I agree&rsquo; box, I confirm that:</p><ul><li>I can access and read this Electronic CONSENT TO ELECTRONIC RECEIPT OF ELECTRONIC CONSUMER DISCLOSURES document; and</li><li>I can print on paper the disclosure or save or send the disclosure to a place where I can print it, for future reference and access; and</li><li>Until or unless I notify $BUSINESS_NAME$, I consent to receive from exclusively through electronic means all notices, disclosures, authorizations, acknowledgements, and other documents that are required to be provided or made available to me by $BUSINESS_NAME$ during the course of my relationship with you.</li></ul>'.replace(placeholder, businessName);
    if (!_.isEmpty(this.state.esignDisclosure.additionalText)) {
      text = `${text}<p><strong>In addition to the above, the sender has added the following custom information:</strong></p>${this.state.esignDisclosure.additionalText}`;
    }

    return (
      <DisclosureModal
        {...this.props}
        header={header}
        content={text}
        onSubmit={this.closeDisclosureModal}
        onClose={this.closeDisclosureModal}
        onDownload={this.downloadDisclosureText}
        showDownloadButton={true}
        showPrintButton={true}
        submitButton={intl.formatMessage(messages.buttonText)} />
    );
  },
});

module.exports = injectIntl(SignatureRequestPreview);
